module.exports = __webpack_public_path__ + "img/baseImg.f1a4a577.svg";